<template>
  <table class="table table-bordered">

    <thead>
      <tr>
        <th>{{$t("Cryptocurrency")}}</th>
        <th>{{$t("Ticker")}}</th>
        <th>{{$t("Share")}}</th>
        <th>{{$t("Value (BGN)")}}</th>
        <th>{{$t("Number of coins")}}</th>
        <th>{{$t("Price (BGN)")}}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="coin in coins">
        <td>{{ coin.name }}</td>
        <td>{{ coin.ticker }}</td>
        <td class="text-right">{{ coin.shareStr }}%</td>
        <td class="text-right">{{ coin.valueBGNstr }}</td>
        <td class="text-right">{{ coin.piecesStr }}</td>
        <td class="text-right">{{ coin.priceBGNstr }}</td>
      </tr>
    </tbody>

  </table>
</template>


<script>
export default {
  props: ['coins'],
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/tables/AssetsTable.vue